import { REQUEST_FAQS, RECEIVE_FAQS } from "actions/faq/faq.actions";

export default (
    state = {
        faqsAreFetching: false,
        faqs: undefined
    },
    action
) => {
    switch (action.type) {
        case REQUEST_FAQS:
            return { ...state, faqsAreFetching: true };
        case RECEIVE_FAQS:
            return {
                ...state,
                faqsAreFetching: false,
                faqs: action.faqs
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/faqReducer.js